/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uCopy = A4uCopy;

var _react = _interopRequireDefault(require("react"));

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function A4uCopy(_ref) {
  var _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 'M' : _ref$scale,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'LIGHT' : _ref$color,
      props = _objectWithoutProperties(_ref, ["scale", "color"]);

  return _react["default"].createElement("svg", _extends({
    viewBox: _util.viewBoxes[scale]
  }, props, props), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 32,
    y: 22
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 32,
    y: 18
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 32,
    y: 14
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 32,
    y: 10
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 32,
    y: 6
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 32,
    y: 2
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 28,
    y: 2
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 24,
    y: 2
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 20,
    y: 2
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 16,
    y: 2
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 12,
    y: 2
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 12,
    y: 6
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 12,
    y: 10
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 12,
    y: 14
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 12,
    y: 18
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 12,
    y: 22
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 16,
    y: 22
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 20,
    y: 22
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 24,
    y: 22
  }), _react["default"].createElement("rect", {
    height: 2,
    rx: 0.5,
    ry: 0.5,
    width: 2,
    x: 28,
    y: 22
  }), _react["default"].createElement("path", {
    d: "M10 12H3a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-7H11a1 1 0 0 1-1-1z"
  }));
}